import { ISelectOptions } from 'framework/components/ui/FormComponents/Select';

export type eventTemplates = 'default' | 'slotTemplate' | 'liveCalendar' | 'liveCalendarOrphan' | 'eventBlocker';
export interface IEvent {
  id?: string;
  template?: eventTemplates;
  options?: any;
  event?: any;
  data?: any;
}

export enum ExpressTimes {
  Instacart2hr = 'instacart-express-2hr',
  Instacart5hr = 'instacart-express-5hr',
}
export enum LastMileServiceTypes {
  Scheduled = 'scheduled',
  ExpressTimeframe = 'express-timeframe',
}

export interface SupportedServiceType {
  identifier: ExpressTimes;
  lastMileServiceType: LastMileServiceTypes;
  label: string;
  value: string;
  sameDayOnly: boolean;
  infiniteCapacity: boolean;
  timeframeInMinutes: number;
  expirationTimeInMinutes: number;
}

export interface IEventComponent {
  id: string | number;
  title?: string;
  desc?: string;
  className?: string;
  disabled?: boolean;
  modified?: boolean;
  event?: IEvent;
  start?: Date;
  end?: Date;
  allDay?: boolean;
  template?: eventTemplates;
  data: {
    day?: number;
    start?: Date;
    startDate?: Date;
    endDate?: Date;
    end?: Date;
    newOrdersCutoff?: string;
    amendOrdersCutoff?: string;
    pickingStartingTime?: string;
    pickByTime?: string;
    fulfillmentType?: ISelectOptions;
    fulfilmentType?: ISelectOptions;
    fulfillmentTypeDisplayName: string;
    capacity?: number;
    availableCapacity?: number;
    orders?: number;
    note?: string;
    price?: number;
    sameDayPrice?: number;
    tags?: ISelectOptions[];
    deliveryAreas?: { id: string }[];
    defaultPickByTime?: string;
    cutoffTime?: Date;
    isExpired?: boolean;
    isClosed?: boolean;
    isClosedNotes?: string;
    infiniteCapacity?: boolean;
    shoppingModeId?: string;
    supportedServiceType?: SupportedServiceType;
  };
}
